// Format an integer amount of minor units (cents) as a localized currency string.
// Falls back to a plain "<amount> <CUR>" string when the locale/currency pair is
// unsupported (Intl throws on an unknown currency code). Shared so the apps stop
// re-declaring the same Intl.NumberFormat wrapper per surface.
export function formatMoney(
  cents: number,
  currency: string,
  locale?: string,
): string {
  try {
    // No explicit fraction-digit override: each currency keeps its ISO default (2 for
    // USD/EUR, 0 for JPY/KRW, 3 for KWD/BHD). Forcing max 2 would show cents on a
    // zero-decimal currency and drop the third digit on a three-decimal one.
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
    }).format(cents / 100);
  } catch {
    return `${(cents / 100).toFixed(2)} ${currency}`.trim();
  }
}
